module.exports = __webpack_public_path__ + "static/media/gear.6f80df63.svg";